module.exports = __webpack_public_path__ + "img/insta-icon.8c63a4df.svg";